import React from "react";

const Copyright = ({ copyright }) => (
  <div className="copyright-container margin-half color-grey">
    <small>{copyright}</small>
  </div>
);

export default Copyright;
